import styled from "@emotion/styled"
import { colors } from "../theme"

export const FooterWrapper = styled.footer`
  background: ${colors.black};
  padding-bottom: 2rem;
`
